<!-- <!doctype html> -->
  <template>
    <header class="page-header">
      <nav class="navbar mega-menu" role="navigation">
        <div class="container-fluid">
          <div class="clearfix navbar-fixed-top">
            <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-responsive"> <span class="sr-only">Toggle navigation</span> <span class="toggle-icon"> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span> </span> </button>
            <a href="#" class="page-logo"><img :src="logo" width="133" height="25" alt="logo"></a>
            <div class="topbar-actions">
              <a href="#" style='position: relative; margin-right: 20px'>
                <img :src="noticeImg" @click="showUnreadNotice()" style="width:25px;">
              </a>
              <template v-if = "totalUnReadNoticeNum != 0">
                <span style="color:#FFF;background-color:#ff0000;display:block;width:20px;height:20px;border-radius:50%;text-align:center;line-height:20px;position:absolute;left:15px;top:0;font-size:12px;z-index: 999">{{totalUnReadNoticeNum}}</span>
              </template>
              <div class="btn-group btn-group-img">
                <button type="button" class="btn btn-sm dropdown-toggle" data-toggle="dropdown" data-hover="dropdown" data-close-other="true"><img :src="userImg" alt="user-image" width="30"></button>
                <span class="login-name" v-html="realName"></span>
                <ul class="dropdown-menu-2tier" role="menu">
                  <li><a href="#" v-on:click="logout"><i class="fa fa-sign-out fa-fw"></i> 退出</a> </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="fixed-collapse">
          <div class="nav-collapse collapse navbar-collapse navbar-responsive">
            <ul class="nav navbar-nav" id="side-menu">
              <a href="#menu" id="at-toggle-menu"><span></span></a>
              <div id="menu-container">
                <div id="menu">
                  <iframe :src="getMenuUrl()" frameborder="0" style="width:100%;height:100%;border-radius: 5px;"></iframe>
                </div>
              </div>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  </template>

  <script>
  import axios from '@/axios/web'
  import {handleInit} from '@/components/js/app.js'
  import {handleHeaderMenu, activeMenu} from '@/components/js/layout.js'
  import {SERVICE_IP_PORT, RESOURCE_IP_PORT, REVIEW_SERVER} from '@/api/server'
  import NoticeServer from "@/api/notice";
  import {formatDate} from "element-ui/src/utils/date-util";
  import noticeConfig from "@/views/notice/noticeConfig"

  let that;

  // hasClass
  function hasClass(elem, className) {
      return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
  }
  // toggleClass
  function toggleClass(elem, className) {
      var newClass = ' ' + elem.className.replace( /[\t\r\n]/g, " " ) + ' ';
      if (hasClass(elem, className)) {
          while (newClass.indexOf(" " + className + " ") >= 0 ) {
              newClass = newClass.replace( " " + className + " " , " " );
          }
          elem.className = newClass.replace(/^\s+|\s+$/g, '');
      } else {
          elem.className += ' ' + className;
      }
  }

  export default {
    name: 'Header',

    mixins: [noticeConfig],

    data () {
      return {
        logo: require('@/assets/images/logo.png'),
        noticeImg: require('@/assets/images/notice-icon.svg'),
        userImg: require('@/assets/images/user-4.png'),
        menu: '',
        realName: '',

        totalUnReadNoticeNum: 0,  //未读消息总数
      }
    },
    methods: {
      getMenuUrl() {
        return '/v3/menus'
      },
      // return `http://localhost:8082/v3/menus`
      logout:function() {
        axios.get('/AthubCloud/menu/logout.do').then(()=>{
          window.location.href=SERVICE_IP_PORT+"/welcome.jsp"
        });
      },

      getTotalUnReadNoticeNum() {
        NoticeServer.noticePerson.list({
          noticeDto: {
            previousDays: this.previousDays,
            endDate: formatDate(new Date(), 'yyyy-MM-dd'),
            status: "PUBLISHED",
          },
          personId: localStorage.getItem('userid'),
        }).then(res => {
          if (res.data.data.length > 0) {
            res.data.data = res.data.data.filter(e => {
              return e.readFlag == 0;
            });
            that.totalUnReadNoticeNum = res.data.data.length;
          } else {
            that.totalUnReadNoticeNum = 0;
          }
        });
      },

      showUnreadNotice(){
        window.open("/noticeInfiniteScroll");
      },
    },

    created() {
      this.realName = "&nbsp;&nbsp;" +(localStorage.getItem("realname")||"");
      //加载菜单
      if(localStorage.getItem("menu")) {
        this.menu = localStorage.getItem("menu");
      }
      else {
        axios.get( SERVICE_IP_PORT + '/menu/getHtmlMenu3.sp?RESOURCE_IP_PORT='+RESOURCE_IP_PORT
            +'&SERVICE_IP_PORT='+SERVICE_IP_PORT)
            .then((data) => {
                this.menu = data.data.menuHtml3;
                localStorage.setItem("menu", this.menu);
            });
      }

      if(!localStorage.getItem("resources")||localStorage.getItem("resources")=="undefined") {
        axios.get(SERVICE_IP_PORT + '/api/sys/getResource.sp')
            .then((data) => {
                console.log(data);
                localStorage.setItem("resources",JSON.stringify(data.data.resources));
            }).catch(error => {
           console.log(error);
        });
      }
    },

    async mounted() {
      that = this;

      //Active Menu
      let m = this.$route.query.m;
      console.log("this.$route.query.m", m)
      if(m) {
        activeMenu(m);
      }
      //Binding Action
      handleInit();
      // handleHeaderMenu();

      this.getTotalUnReadNoticeNum();
      setInterval(this.getTotalUnReadNoticeNum, that.stayIndexSeconds);
      // setInterval(this.getTotalUnReadNoticeNum, 1000*60);
      this.$nextTick(() => {
        var theToggle = document.getElementById('at-toggle-menu');
        theToggle.onclick = function() {
            toggleClass(this, 'on');
            toggleClass(document.getElementById('menu-container'), 'on');
            return false;
        }
      });
    }
  }
  </script>

<style>
  .navbar-toggle {
    display: none !important;
  }
  #at-toggle-menu {
    display: block;
    width: 28px;
    height: 30px;
    margin: 20px auto -8px;
  }

  #at-toggle-menu span:after,
  #at-toggle-menu span:before {
    content: "";
    position: absolute;
    left: 0;
    top: -9px;
  }
  #at-toggle-menu span:after{
    top: 9px;
  }
  #at-toggle-menu span {
    position: relative;
    display: block;
  }

  #at-toggle-menu span,
  #at-toggle-menu span:after,
  #at-toggle-menu span:before {
    width: 100%;
    height: 3px;
    background-color: #fff;
    transition: all 0.3s;
    backface-visibility: hidden;
    border-radius: 2px;
  }

  /* on activation */
  #at-toggle-menu.on span {
    background-color: transparent;
  }
  #at-toggle-menu.on span:before {
    transform: rotate(45deg) translate(5px, 5px);
  }
  #at-toggle-menu.on span:after {
    transform: rotate(-45deg) translate(7px, -8px);
  }
  #menu-container.on {
    opacity: 1;
    display: block;
    visibility: visible;
  }
  .menu-search {
    display: block;
  }
  @media (max-width: 991px) {
    .page-header .navbar-collapse.collapse {
      display: block !important;
      position: absolute !important;
      top: 6px !important;
      right: 8px !important;
    }
    #menu-container {
      top: 42px !important;
      right: 6px !important;
      left: unset !important;
    }
    #menu-container:after {
      left: unset !important;
      right: 22px !important;
    }
  }
  @media screen and (max-width: 1024px) and (min-width: 992px) {
    .page {
        padding-top: 60px !important;
    }
  }

  #menu-container {
    position: absolute;
    opacity: 0;
    left: 6px;
    display: none;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s;
    z-index: 10000;
    margin: auto;
    margin-top: 10px;
    border-radius: 4px;
    height: 80vh;
    width: 250px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  }
  #menu-container:after {
    display: block;
    position: absolute;
    top: -10px;
    left: 22px;
    content: "";
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 15px solid #fff;
  }
  #menu {
    position: relative;
    color: #999;
    font-family: "Segoe UI", Candara, "Bitstream Vera Sans", "DejaVu Sans", "Bitstream Vera Sans", "Trebuchet MS", Verdana, "Verdana Ref", sans-serif;
    text-align: center;
    width:100%;
    height:100%;
  }
</style>
